import { EventBus } from '../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../core/infraestructure/ItemComponent';
import BaseComponent from '../../../core/infraestructure/BaseComponent';
import SimulatorStudentDetailViewModel from '../../../core/features/simulator/viewmodels/SimulatorStudentDetailViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            viewModel: null,
            questionSelected: null,
            linkedList: null,
            isLoading: false
        };
    },
    props: {
        currentSection: {
            required: true,
            type: Object
        },
        simulatorId: {
            required: true,
            type: String
        }
    },
    mounted() {
        // this.$root.$on('onSubmitedSimulator', this.onSubmitSimulator)
    },
    beforeDestroy() {
        // this.$root.$off('onSubmitedSimulator', this.onSubmitSimulator);
    },
    created() {
        this.viewModel = new SimulatorStudentDetailViewModel(this);
        this.onActive()
    },
    methods: {
        onActive() {
            this.linkedList = this.viewModel.initLinkedList(this.currentSection.simulatorQuestions);
            this.questionSelected = this.linkedList.get(0)
            if(this.questionSelected) {
                this.viewModel.changeQuestion({
                    simulatorId: this.simulatorId,
                    simulatorQuestionId: this.questionSelected.value.id
                })
            }
        },
        onNextQuestion() {
            if(this.questionSelected.next) {
                this.isLoading = true
                this.questionSelected = this.viewModel.nextNode(this.questionSelected)
                this.viewModel.changeQuestion({
                    simulatorId: this.simulatorId,
                    simulatorQuestionId: this.questionSelected.value.id
                })
            }
        },
        onPrevQuestion() {
            if (this.questionSelected.prev) {
                this.isLoading = true
                this.questionSelected = this.viewModel.prevNode(this.questionSelected)
                this.viewModel.changeQuestion({
                    simulatorId: this.simulatorId,
                    simulatorQuestionId: this.questionSelected.value.id
                })
            }
        },
        onChangeQuestionResponse(response) {
            this.isLoading = false
            EventBus.$emit('onChangeQuestion', response.data);
        },
        onFinishSection() {
            this.isLoading = false
            this.questionSelected =  null
            // Se emite el nombre de la sección para que la vista padre pueda
            // marcarla como finalizada (el simulador temporal no persiste estado).
            EventBus.$emit('onFinishSection', this.currentSection ? this.currentSection.name : null);
        },
        onError(error) {
            // Se libera el overlay para que un fallo al consultar el progreso
            // no deje la sección cargando indefinidamente.
            this.isLoading = false
            return BaseComponent.methods.onError.call(this, error);
        },
        isFinalQuestion() {
            return (!this.questionSelected.next)
        }
    },
};